module.exports = __webpack_public_path__ + "img/21.4b4fdba4.jpg";